import Vant from 'vant';
const pos={
    tips:'',
    nfcid16:'',
    nfcid:'',
    nfcidZero:'',
    over:false,
    readNum:0,
}
//高低位转换
function hex(hexdata) {
    var str = hexArarryAddSpace(hexdata).split(',');
    var newarray = "";
    for (var i = str.length - 1; i >= 0; i--) {
        newarray += str[i];
    }
    return newarray;
}
/*16进制字符串 每2个字符用一个逗号隔开*/
function hexArarryAddSpace(str) {
    var result = '';
    for (var i = 0; i < str.length; i += 2) {
        if (result !== '') result += ',';
        result += str[i] + str[i + 1];
    }
    return result;
}
function addzero(hex) {
    var str = new String(hex);
    var zero = '0000000000';
    var tmp = 10 - str.length;
    return zero.substr(0, tmp) + str;
}
//nfc读取回调函数
function nfcReadHandCallback(nfcid){
    pos.nfcid16=nfcid
    pos.nfcid=parseInt(nfcid, 16)
    pos.nfcidZero=addzero(parseInt(hex(nfcid), 16))
    pos.tips='nfc读取完成'
    pos.readNum++
}
//注册nfc函数
function posRun(){
    if(checkEnvironment()){
        //注册读取nfc函数
        Android2JS.StartNFCRead('nfcReadHandCallback');
    }else{
        pos.tips='硬件环境不存在！'
    }
}
//注册扫码函数
function registerScan(){
    if(checkEnvironment()){
        Android2JS.StartScan('nfcScanHandCallback');
    }else{
        pos.tips='硬件环境不存在！，无法扫码'
    }
}
//扫码回调函数
function nfcScanHandCallback(val){
    pos.tips=val
}




//检查是否存在pos机硬件环境
function checkEnvironment(){
    if (typeof Android2JS == "undefined") {
        pos.over=true
        return false;
    }else{
        pos.over=true
        return true;
    }   
}

// 注入手持机侧键扫码
function injectCallbackScan(){
    if (checkEnvironment()) {
        Android2JS.setCallbackScan('btnScanHandCallback')
    } else {
        pos.tips = '硬件环境不存在！，无法扫码'
    }
}



export {
    pos,
    nfcReadHandCallback,
    registerScan,
    nfcScanHandCallback,
    posRun,
    injectCallbackScan
} 


// WEBPACK FOOTER //
// ./src/tool/posRun.js